<template>
  <form v-on:submit.prevent="submit">
    <div class="form-group">
      <label class="form-label" for="name">Name</label>
      <input class="form-input" type="text" id="name" v-model="name" />
    </div>

    <div class="form-group">
      <label class="form-label" for="date">Date</label>
      <input class="form-input" type="date" id="date" v-model="date" />
    </div>

    <div class="form-group">
      <label class="form-label" for="venue">Venue</label>
      <input class="form-input" type="text" id="venue" v-model="venue" />
    </div>

    <div class="form-group">
      <label class="form-label" for="type">Type of event</label>
      <select class="form-select" id="type" v-model="type">
        <option value="class">Class</option>
        <option value="tournament">Tournament</option>
      </select>
    </div>

    <div class="actions">
      <button type="reset" class="btn">Reset</button>
      &nbsp;
      <button type="submit" class="btn btn-primary">Create new</button>
    </div>

  </form>
</template>

<script>
  import { EventBus } from '../main'
  import config from "../config"
  import uuid from "../../node_modules/uuid/v4"

  // TODO: add in autofill for the clubs
  export default {
    name : "newevent",
    data () {
      return {
        name : "",
        date : new Date().toISOString().split("T")[0],
        venue : "",
        type : "class"
      }
    },
    methods : {
      submit : function(e){
        fetch(config.baseUrl+"events/create", {
          method : "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          credentials : "include",
          body : JSON.stringify({
            uuid : uuid(),
            date : new Date().toISOString(),
            name : this.name,
            venue : this.venue,
            type : this.type
          })
        }).then(e => {
          return e.json()
        }).then(j => {
          // fire an event here
          // clear the form
          this.name = ""
          this.venue = ""
          this.type = "class"
          EventBus.$emit('newEvent', j)
        })
      }
    }
  }
</script>
